import { IScript } from './../../models/IScript';
import { IBaseAction } from './../base';
import { IProject } from './../../models/IProject';
import * as types from './actionTypes.scriptEditor';

export interface IHighlightLineParams {
    project: IProject,
    scriptName: string,
    lineNumber: number,
    character: number,
    lineType?: string,
    lineOffset?: number,
    scriptsHash?: string
    definitionName?: string
}
export const highlightLine = (param
    : IHighlightLineParams)
    : IHighlightLineParams & IBaseAction => ({
        type: types.HIGHLIGHT_LINE_REQ,
        ...param
    });

export const resetHighlighting = () => ({
    type: types.UNHIGHLIGHT_LINE_REQ,
});

export interface IUpdateScriptTextInEditorParams {
    script: IScript,
    newScriptText: string,
}
export const updateScriptTextInEditor = ({ script, newScriptText }
    : IUpdateScriptTextInEditorParams)
    : IUpdateScriptTextInEditorParams & IBaseAction => ({
        type: types.UPDATE_SCRIPT_TEXT_IN_EDITOR,
        script,
        newScriptText
    });

export interface IChangeEditorFontSizeParams {
    fontSize: number,
}
export const changeEditorFontSize = ({ fontSize }
    : IChangeEditorFontSizeParams)
    : IChangeEditorFontSizeParams & IBaseAction => ({
        type: types.CHANGE_EDITOR_FONT_SIZE_REQ,
        fontSize
    });

export interface IChangeEditorThemeParams {
    codeTheme: string,
}
export const changeEditorTheme = ({ codeTheme }
    : IChangeEditorThemeParams)
    : IChangeEditorThemeParams & IBaseAction => ({
        type: types.CHANGE_EDITOR_THEME_REQ,
        codeTheme
    });

export interface IShowSearchParams {
    searchKey: string, showSearch: boolean, showReplace: boolean
}
export const showSearch = ({ searchKey, showSearch, showReplace }: IShowSearchParams) => ({
    type: types.SCRIPT_SEARCH_SHOW_REQ,
    searchKey,
    showSearch,
    showReplace,
});

export const searchUpdate = () => ({
    type: types.SCRIPT_SEARCH_UPDATE_REQ,
    lastSearchUpdate: Date.now(),
});

export interface ISetSearchTermParams {
    searchKey: string, searchTerm: string
}
export const setSearchTerm = ({ searchKey, searchTerm }: ISetSearchTermParams) => ({
    type: types.SCRIPT_SEARCH_SEARCH_TERM_REQ,
    searchKey,
    searchTerm,
});
export interface ISetReplaceTermParams {
    searchKey: string, replaceTerm: string
}
export const setReplaceTerm = ({ searchKey, replaceTerm }: ISetReplaceTermParams) => ({
    type: types.SCRIPT_SEARCH_REPLACE_TERM_REQ,
    searchKey,
    replaceTerm,
});

export interface ISetSearchMetaParams {
    searchKey: string, currentSearchItem: number, totalSearchResults: number
}
export const setMeta = ({ searchKey, currentSearchItem, totalSearchResults }: ISetSearchMetaParams) => ({
    type: types.SCRIPT_SEARCH_SET_META_REQ,
    searchKey,
    currentSearchItem,
    totalSearchResults,
});

export interface IOpenErrorsParams {
    shouldScrollToFirstError: boolean
}
export const openErrors = ({ shouldScrollToFirstError }: IOpenErrorsParams) => ({
    type: types.OPEN_ERRORS_IN_ERROR_PANEL_REQ,
    shouldScrollToFirstError
});
